import type { IconNode } from '../types';

/**
 * @name messages-circle
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkuOTUgMTAuMDVhNyA3IDAgMDExLjQxMiA3Ljg3MiAxIDEgMCAwMC0uMDU4Ljc4N2wuNjc1IDIuMDg5YTEgMSAwIDAxLTEuMjM2IDEuMTY4bC0yLjE1NS0uNjMxYTEgMSAwIDAwLS43NDUuMDYgNyA3IDAgMDEtNy43OTMtMS40NDUiIC8+CiAgPHBhdGggZD0iTTIuNjk2IDEyLjcwOGExIDEgMCAwMC0uMDU4LS43ODUgNyA3IDAgMTEzLjUxOCAzLjQ3MyAxIDEgMCAwMC0uNzQ0LS4wNjFsLTIuMTU1LjYzYTEgMSAwIDAxLTEuMjM2LTEuMTY3eiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/messages-circle
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const MessagesCircle: IconNode = [
  [
    'path',
    {
      d: 'M19.95 10.05a7 7 0 011.412 7.872 1 1 0 00-.058.787l.675 2.089a1 1 0 01-1.236 1.168l-2.155-.631a1 1 0 00-.745.06 7 7 0 01-7.793-1.445',
    },
  ],
  [
    'path',
    {
      d: 'M2.696 12.708a1 1 0 00-.058-.785 7 7 0 113.518 3.473 1 1 0 00-.744-.061l-2.155.63a1 1 0 01-1.236-1.167z',
    },
  ],
];

export default MessagesCircle;
